import { useI18n } from '@platform/i18n';

/** Counts come from the current user's authorized search response, never an admin inventory. */
export function SearchIndexFooter({ count }: { count: number }) {
  const { t } = useI18n();
  if (count <= 0) return null;
  return <div role="status" className="min-w-0 shrink-0 border-t px-3 py-2 pr-16 text-xs text-muted-foreground md:pr-3">{t('webmail.searchNotFullyIndexed', { count })}</div>;
}
